import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import {
    errorMessage,
    formatDate,
    formatStatus,
    formatUsername,
    permissionAllow,
    permissionCssClass,
} from "../../../util/Helpers";
import SVG from "react-inlinesvg";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { FilterGroup } from "../../Common/components/FilterGroup";
import { Permission } from "../../Common/layout/Permission";
import { EditIcon } from "../../../util/Icons";
import ResolveTransactionModal from "./modals/ResolveTransactionModal";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useSelector } from "react-redux";
import ViewStalledTransactionModal from "./modals/ViewStalledTransactionModal";
import { Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { SubHeader } from "../../Common/layout/SubHeader";
import { useDownloadStalledTransactionsReportMutation } from "../../../../redux/apiSlice";
import { BlockUserModal } from "./modals/BlockUserModal";

export const BalanceRecalculationTable = (
    {
        match: {
            params: { userGroup },
        },
    }
) => {
    const tableRef = useRef();
    const [transactionModal, setTransactionModal] = useState({ showViewStalledTransactionModal: false, details: null });
    const adminUser = useSelector(state => state.auth.user);

    // Modal state for resolving transactions
    const [stalledTransactionModal, setStalledTransactionModal] = useState({
        showResolveTransactionModal: false,
        details: null
    });
    const [blockUserModal, setblockUserModal] = useState({
        showBlockUserModal: false,
        details: null
    });

    const NewtoggleModal = modal => _ => {
        setTransactionModal({ ...transactionModal, [modal]: !transactionModal[modal] })
    }

    const blocktoggleModal = (modal) => (_) => {
        setblockUserModal({ ...blockUserModal, [modal]: !blockUserModal[modal] });
    };


    const toggleModal = modal => _ => {
        setStalledTransactionModal({ ...stalledTransactionModal, [modal]: !stalledTransactionModal[modal] })
    }

    const resolveStalledTransaction = details => {
        setStalledTransactionModal({
            ...stalledTransactionModal,
            showResolveTransactionModal: true,
            details
        })
    }
    const [
        downloadStalledTransactionsReport,
        {
            isLoading: isLoadingReport,
        }
    ] = useDownloadStalledTransactionsReportMutation(userGroup)

    const resolveTransactionAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="View Transaction"
                    className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                    onClick={_ => setTransactionModal({ ...transactionModal, showViewStalledTransactionModal: true, details: row })}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            title="View Transaction"
                            src={toAbsoluteUrl(
                                `/media/svg/icons/${(permissionAllow(adminUser, Permissions.TRANSACTIONS, PermissionType.UPDATE) && row.tranStatus === "pending") ? "Media/Play" : "General/Eye-2"}.svg`
                            )}
                        />
                    </span>
                </Button>

                <Permission permission={Permissions.ACCOUNTS} permissionType={PermissionType.UPDATE}>
                    <Button
                        title="Resolve Transaction"
                        className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3`}
                        onClick={_ => resolveStalledTransaction(row)}
                        disabled={row.status === "corrected"}
                    >
                        <span className={`svg-icon svg-icon-md svg-icon-${(row.status !== "FAILED") ? "muted" : "primary"}`}>
                            <EditIcon />
                        </span>
                    </Button>
                    <Button
                        title="Block User"
                        className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.STALLED_TRANSACTIONS, PermissionType.UPDATE)}`}
                        onClick={_ => setblockUserModal({ ...blockUserModal, showBlockUserModal: true, details: row })}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                                title="Disable User"
                                src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                            />
                        </span>
                    </Button>

                </Permission>
            </span>
        );
    };


    return (
        <div className="py-4 px-6">
            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"Pending Review"} to={`/stalled-transaction/${userGroup}/pending`} />
                    <SubHeader.NavItem label={"Pending System Recalculation"} to={`/stalled-transaction/${userGroup}/debt`} />
                    <SubHeader.NavItem label={"Post-Tech Review "} to={`/stalled-transaction/${userGroup}/tech_resolved`} />
                </SubHeader.Nav>
            </SubHeader>

            <Switch>
                <Redirect exact={true} from={`/stalled-transaction/:userGroup`} to={`/stalled-transaction/${userGroup}/debt`} />

                <ContentRoute path={`/stalled-transaction/:userGroup/debt`}>
                    <FilterGroup
                        key={userGroup}
                        defaultFilters={{ endDate: new Date().toISOString().split('T')[0] }}
                    >

                        <div className="mt-4 mb-4">
                            <FilterGroup.DateRange />
                        </div>
                        <div className="d-flex mb-4">
                            <div className={"mt-4"}>
                                <FilterGroup.Filter name={"stalledTransactionType"} label={"Categories"}>
                                    <FilterGroup.Option value="">All</FilterGroup.Option>
                                    <FilterGroup.Option value="WITHDRAW">WITHDRAW</FilterGroup.Option>
                                    <FilterGroup.Option value="DEPOSIT">DEPOSIT</FilterGroup.Option>
                                    <FilterGroup.Option value="BUY">BUY</FilterGroup.Option>
                                    <FilterGroup.Option value="SELL">SELL</FilterGroup.Option>
                                </FilterGroup.Filter>
                            </div>
                        </div>
                        <FilterGroup.Content>
                            {
                                ({ filters }) => {
                                    return <Card>
                                        <CardHeader title={`Balance Recalculation`} >
                                            <Permission permission={Permissions.REPORTS} permissionType={PermissionType.CREATE}>
                                                <CardHeaderToolbar>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        disabled={isLoadingReport}
                                                        onClick={() => downloadStalledTransactionsReport({
                                                            userGroup,
                                                            startDate: filters?.startDate || "",
                                                            endDate: filters?.endDate || "",
                                                            stalledTransactionType: filters?.stalledTransactionType || "",
                                                            status: filters?.status || "pending_balance_recalculation",
                                                            format: "csv",
                                                        })}
                                                    >
                                                        Export CSV
                                                    </button>
                                                </CardHeaderToolbar>
                                            </Permission>

                                        </CardHeader>
                                        <CardBody>
                                            <DynamicSimpleTable
                                                key={userGroup}
                                                queryParams={
                                                    `userGroup=${userGroup}`
                                                    + `&stalledTransactionType=${filters?.stalledTransactionType || ""}`
                                                    + `&status=pending_balance_recalculation`
                                                    + `&startDate=${filters?.startDate || ""}`
                                                    + `&endDate=${filters?.endDate || ""}`
                                                }
                                                searchBox={true}
                                                source={{ url: `/stalled-transactions` }}
                                                columns={[
                                                    { title: "USER", format: row => formatUsername(row.userId, row.username) },
                                                    {
                                                        title: "FLAGGED COMMENT",
                                                        key: "comment",
                                                        format: row => (
                                                            <div style={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: "150px", maxWidth: "150px" }}>
                                                                {row.comment}
                                                            </div>
                                                        )
                                                    },
                                                    {
                                                        title: "RESOLUTION COMMENT",
                                                        key: "resolutionComment",
                                                        format: row => (
                                                            <div style={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: "200px", maxWidth: "200px" }}>
                                                                {row.resolutionComment}
                                                            </div>
                                                        )
                                                    },
                                                    { title: "TYPE", key: "stalledTransactionType" },
                                                    { title: "AMOUNT", key: "cashCorrectionAmount" },
                                                    ...(filters?.stalledTransactionType === "WITHDRAW" || filters?.stalledTransactionType === "DEPOSIT"
                                                        ? []
                                                        : [{ title: "QUANTITY", key: "positionCorrectionQuantity" }]),
                                                    { title: "STATUS", format: row => formatStatus(row.status) },
                                                    { title: "CREATED", format: row => formatDate(row.created) },
                                                    { title: "UPDATED", format: row => formatDate(row.updated) },
                                                    { title: "", format: resolveTransactionAction }
                                                ]}
                                                
                                                ref={tableRef}
                                                onError={(err) =>
                                                    cogoToast.error(errorMessage(err))
                                                }
                                                refreshIcon={true}
                                            />
                                        </CardBody>
                                    </Card>
                                }
                            }
                        </FilterGroup.Content>
                    </FilterGroup>
                </ContentRoute>
            </Switch>

            {stalledTransactionModal.showResolveTransactionModal &&
                <ResolveTransactionModal
                    {...stalledTransactionModal}
                    onHide={toggleModal("showResolveTransactionModal")}
                    tableRef={tableRef}
                />
            }
            {blockUserModal.showBlockUserModal &&
                <BlockUserModal
                    {...blockUserModal}
                    onHide={blocktoggleModal("showBlockUserModal")}
                    tableRef={tableRef}
                />
            }
            {transactionModal.showViewStalledTransactionModal &&
                <ViewStalledTransactionModal
                    {...transactionModal}
                    onHide={NewtoggleModal("showViewStalledTransactionModal")}
                    tableRef={tableRef}
                />
            }
        </div>
    );
};
